<template>
	<v-navigation-drawer :rail="rail" permanent width="120" rail-width="76" style="position: fixed; top: 64px">
		<v-list density="compact">
			<v-list-item link dense title="" class="d-flex justify-start" subtitle="" @click="rail = !rail">
				<Icon v-if="rail" icon="mdi-chevron-right"></Icon>
				<Icon v-else icon="mdi-chevron-left"></Icon>
			</v-list-item>
			<template v-for="item in items" :key="item.to || item.title">
				<v-list-item v-if="!item.items" link class="pl-0xx" @click="$router.push(item.to)">
					<div class="d-flex flex-row align-center">
						<Icon :icon="item.icon" :style="{ color: item.color || 'inherit' }" width="1.4rem" />
						<span v-if="!rail">
							{{ item.title }}
						</span>
					</div>
				</v-list-item>
				<v-list-group v-else :value="item.to" density="compact">
					<template v-slot:activator="{ props }">
						<v-list-item v-bind="props" class="" style="max-width: 200px">
							<div class="d-flex flex-row align-center">
								<Icon :icon="item.icon" :style="{ color: item.color || 'inherit' }" width="1.4rem" />
								<span v-if="!rail">
									{{ item.title }}
								</span>
							</div>
						</v-list-item>
					</template>
					<template v-for="sub in item.items" :key="sub.to || sub.title">
						<v-list-item link class="" @click="$router.push(sub.to)">
							<div class="d-flex flex-row align-center">
								<Icon :icon="sub.icon" :style="{ color: sub.color || 'inherit' }" width="1.4rem" />
								<span v-if="!rail">
									{{ sub.title }}
								</span>
							</div>
						</v-list-item>
					</template>
				</v-list-group>
			</template>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import { useVisitorStore } from '@/stores/visitor'
import { mapState } from 'pinia'

function filterMenu(menu, allowed, all) {
	if (all) return menu
	const set = new Set(allowed || [])
	return (menu || [])
		.map((item) => {
			if (item.items?.length) {
				const children = item.items.filter((sub) => sub.to && set.has(sub.to))
				if (!children.length) return null
				return { ...item, items: children }
			}
			if (item.to && set.has(item.to)) return item
			return null
		})
		.filter(Boolean)
}

export default {
	components: {},
	props: {},
	data() {
		return {
			rail: false,
			menuAll: false,
			menuKeys: [],
			menusLoaded: false
		}
	},
	computed: {
		...mapState(useVisitorStore, ['isLoggedIn', 'isAdmin', 'roleCodes']),
		items() {
			const raw = this.$soul?.menu || []
			if (!this.isLoggedIn) return []
			if (this.isAdmin || this.menuAll) return raw
			if (!this.menusLoaded) return []
			return filterMenu(raw, this.menuKeys, false)
		}
	},
	watch: {
		isLoggedIn: {
			immediate: true,
			handler(v) {
				if (v) this.loadMenus()
				else {
					this.menuAll = false
					this.menuKeys = []
					this.menusLoaded = false
				}
			}
		},
		isAdmin(v) {
			if (v && this.isLoggedIn) {
				this.menuAll = true
				this.menusLoaded = true
			}
		},
		// 角色被重新分配后刷新菜单权限
		roleCodes() {
			if (this.isLoggedIn) this.loadMenus()
		}
	},
	methods: {
		loadMenus() {
			if (this.isAdmin) {
				this.menuAll = true
				this.menusLoaded = true
			}
			if (!this.$api?.acl?.myMenus) {
				this.menuAll = this.isAdmin || this.menuAll
				this.menusLoaded = true
				return
			}
			this.$api.acl.myMenus(
				(res) => {
					this.menuAll = !!res?.all || this.isAdmin
					this.menuKeys = res?.menu_keys || []
					this.menusLoaded = true
				},
				() => {
					// 接口失败时不锁死侧栏：管理员仍看全部
					this.menuAll = this.isAdmin
					this.menuKeys = []
					this.menusLoaded = true
				}
			)
		},
		goTo(to) {
			this.$router.push(to)
		}
	}
}
</script>

<style>
.v-list-item__append {
	max-width: 24px !important;
	width: 24px !important;
	padding: 0;
	margin: 0;
	display: unset !important;
}

.v-navigation-drawer {
	z-index: 1000;
}
</style>
